var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9999,
    cy: 19.9999,
    r: 19.4999,
    fill: "white",
    stroke: "#D0D5DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C8.95538 0 0 8.95538 0 20C0 31.0446 8.95538 40 20 40C31.0446 40 40 31.0446 40 20C40 8.95538 31.0446 0 20 0ZM15.2546 28.4514H11.6955V16.9974H15.2546V28.4514ZM13.4803 15.4331C12.336 15.4331 11.4121 14.5092 11.4121 13.3648C11.4121 12.231 12.336 11.3071 13.4803 11.3071C14.6142 11.3071 15.5381 12.231 15.5381 13.3648C15.5381 14.5092 14.6142 15.4331 13.4803 15.4331ZM28.5879 28.4514H25.0289V22.8871C25.0289 21.5643 25.0079 19.853 23.1811 19.853C21.3333 19.853 21.0499 21.3018 21.0499 22.7927V28.4619H17.4908V16.9974H20.9029V18.5617H20.9554C21.4278 17.6588 22.5932 16.7139 24.3255 16.7139C27.9265 16.7139 28.5984 19.0866 28.5984 22.1732V28.4514H28.5879Z",
    fill: "#0076B2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinked);
export default __webpack_public_path__ + "static/media/linked.cb4444e301639068fef32ff5cf4fb1ae.svg";
export { ForwardRef as ReactComponent };